import { Link } from "react-router-dom";

const COLUMNS: { title: string; links: { label: string; to: string }[] }[] = [
  {
    title: "榜单导航",
    links: [
      { label: "人气排行榜", to: "/ranking" },
      { label: "高分佳作", to: "/top-rated" },
      { label: "题材分类", to: "/genres" },
      { label: "常见问题", to: "/faq" },
    ],
  },
  {
    title: "了解更多",
    links: [
      { label: "关于我们", to: "/about" },
      { label: "网站定位", to: "/about" },
      { label: "内容原则", to: "/about" },
      { label: "联系我们", to: "/about" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="mt-auto border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2 lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 whitespace-nowrap" aria-label="人气韩漫大全首页">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-book-open-fill text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                人气<span className="text-primary-600">韩漫大全</span>
              </span>
            </Link>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              汇聚人气韩漫排行榜、高分佳作推荐与题材分类，实时更新热门韩漫热度排名，帮你快速锁定当前最值得追的韩漫，追更不迷路。
            </p>
            <div className="mt-5 flex gap-3">
              <a href="mailto:hello@manhwa-daquan.example" aria-label="发送邮件" className="flex h-10 w-10 items-center justify-center rounded-lg bg-background-50 text-foreground-700 transition-colors hover:bg-secondary-200 hover:text-secondary-900">
                <i className="ri-mail-line"></i>
              </a>
              <a href="mailto:hello@manhwa-daquan.example" aria-label="订阅推送" className="flex h-10 w-10 items-center justify-center rounded-lg bg-background-50 text-foreground-700 transition-colors hover:bg-secondary-200 hover:text-secondary-900">
                <i className="ri-notification-3-line"></i>
              </a>
              <a href="mailto:hello@manhwa-daquan.example" aria-label="反馈建议" className="flex h-10 w-10 items-center justify-center rounded-lg bg-background-50 text-foreground-700 transition-colors hover:bg-secondary-200 hover:text-secondary-900">
                <i className="ri-chat-3-line"></i>
              </a>
            </div>
          </div>

          {COLUMNS.map((col) => (
            <nav key={col.title} aria-label={col.title}>
              <h3 className="font-label text-sm font-semibold uppercase tracking-wide text-foreground-500">{col.title}</h3>
              <ul className="mt-4 space-y-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link to={link.to} className="whitespace-nowrap text-sm text-foreground-700 transition-colors hover:text-primary-600">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">© {new Date().getFullYear()} 人气韩漫大全 · 追更不迷路</p>
          <p className="text-xs text-foreground-500">本站仅提供韩漫作品介绍与榜单推荐，内容版权归原作者及版权方所有。</p>
        </div>
      </div>
    </footer>
  );
}